import { Anchor, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router';

export function NaoEncontrada() {
  return (
    <Stack>
      <Title order={3}>Página não encontrada</Title>
      <Text>
        Se ela ainda não foi migrada, use o menu: as páginas marcadas “legado” abrem a versão atual.
      </Text>
      <Anchor component={Link} to="/">
        Voltar ao início
      </Anchor>
    </Stack>
  );
}
